var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-space-between"},_vm._l((_vm.buttons),function(button){return _c('v-btn',{key:button.id,attrs:{"color":"accent","disabled":button.disabled || _vm.disabled},on:{"click":function($event){return _vm.buttonClickThrottle(button)}}},[_vm._v(" "+_vm._s(button.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }